import React, { useState } from "react";
import "leaflet/dist/leaflet.css";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import { LOCATION, SITE_NAME, ROUTE_URL } from "../../config/location";

const customIcon = new L.Icon({
    iconUrl: markerIcon,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [0, -36],
});

// OpenStreetMap wird erst nach Klick geladen (Datenschutz).
const LazyLoadedMap = () => {
    const [mapLoaded, setMapLoaded] = useState(false);
    const routeUrl = ROUTE_URL;

    return (
        <div className="reveal relative z-0 h-[clamp(360px,55vh,560px)] border border-forest/10">
            {mapLoaded ? (
                <MapContainer center={LOCATION.center} zoom={16} scrollWheelZoom={false} className="h-full w-full">
                    <TileLayer
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        attribution="&copy; <a href='http://osm.org/copyright'>OpenStreetMap</a> contributors"
                    />
                    <Marker position={LOCATION.center} icon={customIcon}>
                        <Popup>
                            <strong>{SITE_NAME}</strong>
                            <br />
                            {LOCATION.venue}, {LOCATION.street}
                            <br />
                            <a href={routeUrl} target="_blank" rel="noreferrer">
                                Route planen
                            </a>
                        </Popup>
                    </Marker>
                </MapContainer>
            ) : (
                <div className="flex h-full flex-col items-center justify-center gap-4 bg-[repeating-linear-gradient(135deg,#e4ded0_0_12px,#ece6d9_12px_24px)] px-6 text-center">
                    <button type="button" onClick={() => setMapLoaded(true)} className="btn btn-primary px-6 py-3.5 text-[13px]">
                        Karte laden
                    </button>
                    <div className="max-w-[420px] text-sm text-forest/70">
                        Dabei werden Inhalte von OpenStreetMap geladen und Ihre IP-Adresse an deren Server übertragen.
                    </div>
                    <a href={routeUrl} target="_blank" rel="noreferrer" className="text-sm underline">
                        Route in Google Maps öffnen
                    </a>
                </div>
            )}
        </div>
    );
};

export default LazyLoadedMap;
